<template>
  <v-dialog max-width="500px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <v-btn color="red" small v-on="on" outlined>
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <h1 class="title">Participacion</h1>
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-autocomplete
            v-model="partEdith.rol"
            :items="roles"
            label="Rol"
            autofocus
            :rules="[rules.required]"
          />
          <v-text-field
            label="Nombres"
            :rules="[rules.required]"
            v-model="partEdith.nombres"
            v-if="showDialog"
          ></v-text-field>
          <v-text-field
            label="Apellidos"
            :rules="[rules.required]"
            v-model="partEdith.apellidos"
          ></v-text-field>
          <v-text-field
            label="% Ejecucion"
            :rules="[rules.required]"
            v-model="partEdith.porcentajeEjecucion"
          ></v-text-field>

          <v-text-field
            label="%Mecanico"
            :rules="[rules.required]"
            v-model="partEdith.porcentajeMecanico"
          ></v-text-field>

          <v-text-field
            label="%Syncro"
            :rules="[rules.required]"
            v-model="partEdith.porcentajeSyncro"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" outlined small @click="showDialog = false"
          >Volver</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="red" outlined small @click="save">Guardar</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["icon", "participacion"],
  data() {
    return {
      partEdith: {},
      roles: [
        "Autor",
        "Compositor",
        "CompositorAutor",
        "Editor",
        "Subeditor",
        "Arreglador",
        "Adaptador"
      ],
      showDialog: false,
      rules: {
        required: value => !!value || "Requerido.",
        counter: value => value.length <= 1000 || "Maximo 100 caracteres"
      }
    };
  },
  methods: {
    save() {

      if (!this.$refs.form.validate()) {
        return;
      }

      this.showDialog = false;

      if (this.participacion) {
        this.$emit("save", { old: this.participacion, new: this.partEdith });
      } else {
        this.$emit("save", { old: this.participacion, new: this.partEdith });
        this.$refs.form.reset();
        this.partEdith = {};
      }
    }
  },
  mounted() {
    if (this.participacion) {
      this.partEdith = { ...this.participacion };
    }
  }
};
</script>
